import React, { useMemo } from 'react'
import { useSelector } from 'react-redux';

function useData(STATE_KEY: string) {
    const { loading,...rest } = useSelector((state: any) => state[STATE_KEY])
    const data = useMemo(() => rest.data,  [rest.data]);
    return { loading, data: data }
}

export default useData